<template>
  <div class="min-h-screen relative">
    <Header />

    <div
      class="min-h-screen container mx-auto max-w-[1200px] w-full mb-10 py-7 flex flex-col gap-10 px-4 md:px-6 lg:gap-16"
    >
      <div>
        <div class="flex flex-row items-center justify-between">
          <p
            class="text-[#0F172A] text-xl sm:text-2xl md:text-3xl font-semibold"
          >
            Support System
          </p>
          <div class="flex justify-end px-6">
            <router-link
              :to="{ name: 'StudentHome' }"
              class="bg-blues text-white rounded-lg text-sm font-semibold px-5 py-1"
              >Back</router-link
            >
          </div>
        </div>
        <div class="flex justify-center pt-5">No Data Found</div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from "axios";
import Footer from "@/components/Footer.vue";
import Header from "@/components/Student/Header.vue";
import { mapGetters } from "vuex";
export default {
  name: "CompleteCourse",
  data() {
    return {};
  },

  components: {
    Header,
    Footer,
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },
  created() {},
  methods: {},
};
</script>

<style></style>
